define('Components/GlossaryWidget/js/GlossaryWidget',[
        'hooks',
        'Components/GlossaryWidget/js/views/GlossaryWidgetInstanceView',
        'Components/GlossaryWidget/js/models/GlossaryWidgetInstanceModel',
    ],
    function (hooks, GlossaryWidgetInstanceView, GlossaryWidgetInstanceModel) {

        return function () {
            hooks.registerWidgetInstance(
                'GlossaryWidget',
                GlossaryWidgetInstanceView,
                GlossaryWidgetInstanceModel
            );
        }
    });
